import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthShell } from "@/components/AuthShell";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email.trim(), password);
      toast.success(`Welcome back, ${user.full_name}`);
      navigate(user.role === "superadmin" ? "/superadmin" : "/app/dashboard");
    } catch (err) {
      toast.error(errMsg(err, "Invalid email or password"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Sign in to FHAPAS" subtitle="Access your organisation workspace"
      footer={<>New organisation? <Link to="/signup" data-testid="link-signup" className="font-semibold text-teal-700 hover:underline">Register here</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5">
          <Label>Email</Label>
          <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@hospital.com" />
        </div>
        <div className="space-y-1.5">
          <Label>Password</Label>
          <PasswordInput data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" />
        </div>
        <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-teal-700 hover:bg-teal-800">
          {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>
      <div className="mt-5 text-center text-sm text-slate-500">
        Are you a patient? <Link to="/patient" data-testid="link-patient-portal" className="font-semibold text-teal-700 hover:underline">Patient portal</Link>
      </div>
    </AuthShell>
  );
}
